// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Redirect,
    RouteComponentProps,
    withRouter,
} from 'react-router';
import LoginForm from 'common/modules/auth/containers/LoginForm/LoginForm';
import LogoBox from 'common/modules/auth/components/LogoBox/LogoBox';
import { AuthPageHeader } from 'common/components/styles/AuthPageHeader';
import AuthLanguageDropdown from 'common/modules/auth/containers/AuthLanguageDropdown/AuthLanguageDropdown';
import {
    pathTo,
    pathToHome,
} from 'common/helpers/core';
import { AuthContainer } from 'common/modules/auth/Styles';

export type AuthLoginProps =
    RouteComponentProps &
    ReturnType<typeof mapStateToProps>;

export const AuthLogin: React.FC<AuthLoginProps> = ({ auth }) => {
    if (auth.isAuth) {
        return (<Redirect to={pathToHome()} />);
    }

    if (auth.user.is_two_factor_auth_enabled) {
        return (<Redirect to={pathTo('login/2fa')} />);
    }

    return (
        <AuthContainer>
            <AuthPageHeader>
                <LogoBox />
                <AuthLanguageDropdown />
            </AuthPageHeader>
            <LoginForm />
        </AuthContainer>
    );
};

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});

export default withRouter(connect(mapStateToProps)(AuthLogin));
